import config from '@/config'
import { Route } from '@/contracts/core/api/entity/Route'

/** Маршруты модуля groups: работать ли без сервера, решает настройка модуля в src/config.ts */
export abstract class GroupsRoute<P, T> extends Route<P, T> {
  isOffline(): boolean {
    return config.systemModules.groups.offline === 'true'
  }
}
